import React from 'react';
import { useSelector } from 'react-redux';
import { keyframes, styled } from 'styled-components';
import { Size } from '../design-system.js';
import THEME from '../theme.js';
const Checkbox = (props) => {
    const placeholder = React.createElement(StyledPlaceholder, null, props.placeholder);
    const theme = useSelector(() => THEME);
    return (React.createElement(Wrapper, { className: `${props.className} iris-input-container checkbox-wrapper`, style: props.style, setting: props.setting, size: props.size },
        props.setting && placeholder,
        props.checkMark ? (React.createElement(CheckboxCheckMark, { className: props.loading ? 'loading' : undefined, style: props.checkboxStyle, setting: props.setting, boxSize: props.size, disabled: props.disabled, onChange: props.onChange, value: props.value, checked: props.checked, type: "checkbox", theme: theme })) : (React.createElement(CheckboxStyled, { className: props.loading ? 'loading' : undefined, style: props.checkboxStyle, setting: props.setting, boxSize: props.size, disabled: props.disabled, onChange: props.onChange, value: props.value, checked: props.checked, type: "checkbox", theme: theme })),
        !props.setting && placeholder));
};
export default Checkbox;
const Wrapper = styled.label `
  margin-bottom: 20px;
  display: ${(props) => {
    if (props.size == Size.Small && !props.setting) {
        return 'inline';
    }
    if (props.setting) {
        return 'flex';
    }
    else {
        return 'block';
    }
}};
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
const StyledPlaceholder = styled.div `
  display: inline-block;
  max-width: calc(100% - 70px);
  vertical-align: middle;
`;
const beat = keyframes `
  0% {
    filter: opacity(1)
  }

  100% {
    filter: opacity(0.5);
  }
`;
const CheckboxStyled = styled.input `
  &[type='checkbox'] {
    font-size: ${(props) => props.setting || props.boxSize == Size.Small ? '1em' : '30px'};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 2em;
    height: 1em;
    background: #ddd;
    border-radius: 3em;
    position: relative;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    outline: none;
    -webkit-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    margin: 0;
    vertical-align: middle;
    margin-right: ${(props) => (props.setting ? '0' : '10px')};
    margin-left: ${(props) => (props.boxSize == Size.Small ? '5px' : '0')};
  }

  &[type='checkbox'].loading {
    animation: ${beat} 1000ms ease-in-out infinite alternate;
  }

  &[type='checkbox']:checked {
    background: ${(props) => props.theme.COLOR_PRIMARY};

    ${(props) => props.disabled ? `background: ${props.theme.COLOR_GREY};` : ''}
  }

  &[type='checkbox']:after {
    position: absolute;
    content: '';
    width: 1em;
    height: 1em;
    border-radius: 50%;
    background: #fff;
    -webkit-box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
    -webkit-transform: scale(0.7);
    transform: scale(0.7);
    left: 0;
    -webkit-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  &[type='checkbox']:checked:after {
    left: calc(100% - 1em);
  }
`;
const CheckboxCheckMark = styled.input `
  &[type='checkbox'] {
    font-size: ${(props) => props.setting || props.boxSize == Size.Small ? '1em' : '30px'};
    width: 0.8em;
    height: 0.8em;
    position: relative;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    outline: none;
    margin: 0;
    vertical-align: middle;
    margin-right: ${(props) => (props.setting ? '0' : '10px')};
    margin-left: ${(props) => (props.boxSize == Size.Small ? '5px' : '0')};
    accent-color: ${(props) => props.theme.COLOR_ACCENT};
  }

  &[type='checkbox'].loading {
    animation: ${beat} 1000ms ease-in-out infinite alternate;
  }
`;
//# sourceMappingURL=Checkbox.js.map